import { useTranslation } from 'react-i18next';
import { Button, Icon, Space } from 'Components';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useHistory } from 'react-router-dom';
import ModalContextProvider, { useModal } from 'Hooks/useModal';
import RolesActionsModals, {
	RolesActionsModalsProps
} from './RolesActionsModals';
import { PermissionCode } from 'Services/Api/Users/Types';
import { usePermission } from 'Components/Permission/Permission.hooks';
import RolesExportButton, {
	RolesExportButtonProps
} from './components/RolesExportButton';
import "./styles/Roles.module.scss";

type RolesActionsContentProps = RolesActionsModalsProps &
	RolesExportButtonProps & {
		selectedTenantValue: number;
		hasData: boolean,
	};
function RolesActionsContent(props: RolesActionsContentProps) {
	const permission = usePermission();
	const history = useHistory();
	const { t } = useTranslation();

	const onAdd = () => {
		history.push(getAppRoutes().ADD_ROLE);
	};

	const {
		permittedByCode: {
			[PermissionCode.CloneSystemRole]: isClonePermitted,
			[PermissionCode.DeleteSystemRole]: isDeletePermitted,
			[PermissionCode.AddSystemRole]: isAddPermitted,
			[PermissionCode.ExportSystemRoles]: isExportPermitted
		}
	} = permission.getHasPermission({
		code: [
			PermissionCode.CloneSystemRole,
			PermissionCode.DeleteSystemRole,
			PermissionCode.AddSystemRole,
			PermissionCode.ExportSystemRoles
		]
	});

	return (
		<>
			<RolesActionsModals {...props} />
			<Space>
				{isExportPermitted && (
					<RolesExportButton
						params={props.params}
						disabled={!props.hasData}
					/>
				)}

				{!!props.selectedTenantValue && (
					<Button
						type="primary"
						shape="round"
						className="add-role-button"
						icon={<Icon type="plus" />}
						onClick={onAdd}
					>
						{t('roles.add')}
					</Button>
				)}
			</Space>
		</>
	);
}

const RolesActions = (props: RolesActionsContentProps) => (
	<ModalContextProvider>
		<RolesActionsContent {...props} />
	</ModalContextProvider>
);

export default RolesActions;
